import { useState } from "react";
import { api } from "@/lib/api";
import { useQuery } from "@/lib/useQuery";
import { Button } from "@/components/ui";

interface Template { id: string; name: string; subject: string; body: string }

export function TemplatePicker({ onPick, accountId, contactName }: { onPick: (t: { subject: string; body: string }) => void; accountId?: string; contactName?: string | null }) {
  const [open, setOpen] = useState(false);
  const { data } = useQuery<Template[]>("templates", () => api.get<Template[]>("/inbox/templates"));
  const { data: acct } = useQuery<{ name: string }>(accountId ? `account:${accountId}` : null, () => api.get(`/accounts/${accountId}`));
  const fill = (s: string) => {
    const first = (contactName ?? "").split(" ")[0];
    return s.replace(/\{\{\s*contact\.first\s*\}\}/g, first || "there").replace(/\{\{\s*contact\.name\s*\}\}/g, contactName ?? "").replace(/\{\{\s*account\.name\s*\}\}/g, acct?.name ?? "").replace(/\{\{\s*me\.name\s*\}\}/g, "");
  };
  return (
    <div style={{ position: "relative", display: "inline-flex" }}>
      <Button size="md" onClick={() => setOpen((o) => !o)}>Template</Button>
      {open && (
        <div className="menu" style={{ left: 0, bottom: "calc(100% + 4px)", minWidth: 220 }}>
          {(data ?? []).length === 0 && <div className="muted small" style={{ padding: "6px 10px" }}>No templates. Add them under Admin.</div>}
          {(data ?? []).map((t) => <button key={t.id} onClick={() => { setOpen(false); onPick({ subject: fill(t.subject), body: fill(t.body).replace(/\n/g, "<br>") }); }}>{t.name}</button>)}
        </div>
      )}
    </div>
  );
}
